import React from 'react';
import './Header.css';

function Header() {
  return (
    <header className="header">
      <h1>BANSAL MOTORS</h1>
      <p>Authorised Commercial Vehicle Dealer | Est. 2002</p>
      <p>GSTNO. 06AAFFB8538H1ZD</p>
    </header>
  );
}

export default Header;
